module.exports = __webpack_public_path__ + "static/landing-14d15832a3172c2e75b793a84638d0ee.png";